export default {
  /** @name 默认显示扫码组件，更改为false，则隐藏 */
  defaultVisiableScan: {
    type: Boolean,
    default: true,
  },
  /** @name 配合panguTab，当tab=0，是否隐藏此扫码组件 */
  tabIsFirstHiddenScan: {
    type: Boolean,
    default: false,
  },
  /** @name 键名转换映射表 */
  propMap: {
    type: Object,
    default() {
      return {
        batchNumber: `${this.dataGoodsKeepingKey}.batchNumber`,
        serialNumber: `${this.dataGoodsKeepingKey}.serialNumber`,
        periodBegin: `${this.dataGoodsKeepingKey}.periodBegin`,
        periodEnd: `${this.dataGoodsKeepingKey}.periodEnd`,
      }
    },
  },
  /** @name 绑定DI码 */
  scanBindDiProps: {
    type: Object,
    default() {
      return {}
    },
  },
  /** @name 更新生产许可证号接口 */
  queryCertificationUrl: {
    type: String,
    default: 'rest/ezscc/goods/queryCertificationCertsV2',
  },
  /** @name 更新生产许可证号接口参数 */
  queryCertificationParams: {
    type: Object,
    default() {
      return {}
    },
  },
  /** @name 更新注册证号并带出生产许可证号接口 */
  queryRegistAndCertificationUrl: {
    type: String,
    default: 'rest/ezscc/goods/selectCertsByPeriodV2',
  },
  /** @name 获取udi解析规则 */
  udiRulesUrl: {
    type: String,
    default: 'rest/main/goods/goods/getOfEditAdvance',
  },
  /**
   * @name 是否启动校验规则
   * @description
   * #10091 当发现单据内同一商品同一批号下（注意不仅限于扫码组件表格内容哈）
   * 存在相同序列号时，立即进行拦截提示：“同商品同批号下已经存在相同的序列号” */
  enableValidation: {
    type: Boolean,
    default: false,
  },
}
